import React from 'react';
import { LoginEvents, SeamlessDeniedState } from '../types';
import { LoginFlowManager } from './LoginFlowManager';
import { LoginErrorScreen } from './LoginErrorScreen';

export const LoginSwitch = ({
  ehrCredentials,
  credentialsMetadata,
  reLoginConfig,
  organizationId,
  contactDetails,
  isSeamlessLoginFailed,
  wasSeamlessLoginShownAndDenied,
  seamlessShowOtherLoginMethodsOption,
  goBackToSeamlessLogin,
}: LoginEvents & SeamlessDeniedState & { seamlessShowOtherLoginMethodsOption?: boolean }) => {
  if (reLoginConfig)
    return (
      <LoginErrorScreen
        message={reLoginConfig.message}
        title={reLoginConfig.title}
        showLockImage={reLoginConfig.showLockImage}
      />
    );

  if (
    ehrCredentials &&
    (ehrCredentials.password ||
      credentialsMetadata?.shouldShowCredentialsWithError || // Show Ops when seamless login fails above the otp & credentials
      credentialsMetadata?.isEhrPasswordOptional || // When seamless fail we don't require ehr password on otp & credentials UI, but on SSO currently it's mandatory.
      seamlessShowOtherLoginMethodsOption) // If we show other login methods option on seamless login (based on flag), before it was only when having ehr password exists which is not relevant.
  )
    return (
      <LoginFlowManager
        ehrCredentials={ehrCredentials}
        credentialsMetadata={credentialsMetadata}
        organizationId={organizationId}
        contactDetails={contactDetails}
        isSeamlessLoginFailed={isSeamlessLoginFailed}
        wasSeamlessLoginShownAndDenied={wasSeamlessLoginShownAndDenied}
        goBackToSeamlessLogin={goBackToSeamlessLogin}
      />
    );
};
